import Public from '@model/public';
import User from '@model/user';
import Page from '@model/page';
import SSO from '@model/sso';

export default {
  Public,
  User,
  Page,
  SSO
};